export const formField = {
    slots: {
        error: 'text-red-800',
    },
    variants: {
        required: {
            true: {
                label: 'after:text-red-800',
            },
        },
    },
}
